import type { IanaTimezone } from '#/types/TypedDateString';

export function dateInstanceToStringParts(
  date: Date,
  { timezone }: { timezone: IanaTimezone | null },
) {
  // Format as the new timezone
  const newTimezoneFormattedPartsArray = new Intl.DateTimeFormat('en', {
    timeZone: timezone || undefined,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const newTimezoneFormattedParts = Object.fromEntries(
    newTimezoneFormattedPartsArray.map(({ type, value }) => [type, value]),
  );

  // Return new ISO date
  return {
    date: `${newTimezoneFormattedParts.year}-${newTimezoneFormattedParts.month}-${newTimezoneFormattedParts.day}`,
    time: `${newTimezoneFormattedParts.hour}:${newTimezoneFormattedParts.minute}:${newTimezoneFormattedParts.second}`,
  };
}
